<template>
  <section class="main-content clearfix">
    <Lefter></Lefter>
    <div class="right-container clearfix">
      <Title name="最新公告">
        <template v-slot:rightLink>
          <a href="javascript:;" @click="more">查看更多 &gt;</a>
        </template>
      </Title>
      <List></List>
    </div>
  </section>
</template>

<script>
import Lefter from './lefter.vue'
import Title from './title.vue'
import List from './list.vue'
export default {
  name: '',
  data () {
    return {

    }
  },
  methods: {
    more () {
      this.$router.push({
        name: 'Notice'
      })
    }
  },
  components: {
    Lefter,
    Title,
    List
  }
}
</script>

<style lang="scss" scoped>

.main-content {
  margin: 10px 0;
  position: relative;
  overflow: hidden;
  .right-container {
    margin-left: 422px;
    background: #fff;
    padding-left: 30px;
    padding-right: 30px;
    min-height: 495px;
  }
}
</style>
